export const dbCountries = [
    { id: 'AU', name: 'Australia' },
    { id: 'BR', name: 'Brazil' },
    { id: 'CN', name: 'China' },
    { id: 'EG', name: 'Egypt' },
    { id: 'FR', name: 'France' },
    { id: 'DE', name: 'Germany' },
    { id: 'IN', name: 'India' },
    { id: 'JP', name: 'Japan' },
    { id: 'ES', name: 'Spain' },
    { id: 'US', name: 'United States' }
]

